import {
  Button,
  Col,
  Divider,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import range from "helpers/range";

import service_date_delays from "helpers/options/service_date_delays";
import useUpdate from "hooks/useUpdate";
import InputDate from "components/InputDate";
import { useWorkers } from "context/providers/workers";

const disabledDateTime = () => ({
  disabledMinutes: () => [
    ...range(1, 15),
    ...range(16, 30),
    ...range(31, 45),
    ...range(46, 60),
  ],
});

const EditIssue = ({ issue, handleConfirm, refetch, close }) => {
  const { workers_list_options } = useWorkers();
  const [worker_id, setWorkerId] = useState(issue.worker?.id);
  const { is_saving, update } = useUpdate({
    path: `/issues/${issue.id}/set_service_date`,
    onSuccess: () => {
      close();
      refetch();
      handleConfirm();
    },
  });

  const handleSubmit = async (values) => {
    const service_date = dayjs(values.service_date).format();
    update({
      worker_id,
      service_date,
      service_date_delay: values.service_date_delay,
    });
  };

  return (
    <Modal
      width={700}
      title="Edytuj zgłoszenie"
      open={true}
      footer={null}
      onCancel={close}
    >
      <Form
        id="day_modal"
        layout="vertical"
        initialValues={{
          service_date: dayjs(issue.service_date),
          service_date_delay: issue.service_date_delay || 0,
          worker_id: null,
        }}
        onFinish={handleSubmit}
      >
        <Space direction="vertical" style={{ marginBottom: 15, width: "100%" }}>
          <Typography>
            <Typography.Text>Zgłoszenie: </Typography.Text>
            <br />
            <Typography.Text>
              <strong>{issue?.client_address}</strong>
            </Typography.Text>

            <Typography.Text style={{ display: "block", marginTop: 10 }}>
              Data utworzenia:{" "}
            </Typography.Text>
            <Typography.Text>
              <strong>
                {dayjs(issue?.created_at).format("DD-MM-YYYY HH:mm")}
              </strong>
            </Typography.Text>
          </Typography>
        </Space>
        <Row gutter={[12, 12]}>
          <Col xs={24} md={24} lg={12} xl={12}>
            <Form.Item label="Data umówienia" name="service_date" readOnly>
              <InputDate
                format="DD-MM-YYYY HH:mm"
                showTime={{ format: "HH:mm" }}
                disabledTime={disabledDateTime}
                getPopupContainer={() => document.querySelector("#day_modal")}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={24} lg={12} xl={12}>
            <Form.Item
              label="Data umówienia (opóźnienie)"
              name="service_date_delay"
              tooltip="Dostępność klienta w podanym przedziale czasowym"
            >
              <Select
                placeholder="Data umówienia (opóźnienie)"
                options={service_date_delays}
                defaultValue={service_date_delays[0]}
                getPopupContainer={() => document.querySelector("#day_modal")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[12, 12]}>
          <Col xs={24} md={24} lg={12} xl={12}>
            <Typography className="m-b-5">
              <Typography.Text>Pracownicy</Typography.Text>
            </Typography>
            <Select
              style={{ width: "100%" }}
              value={worker_id}
              getPopupContainer={() => document.querySelector("#day_modal")}
              placeholder="Wybierz pracownika"
              allowClear
              filterOption={false}
              onChange={(id) => setWorkerId(id || null)}
              options={workers_list_options || []}
            />
          </Col>
        </Row>
        <Divider size="medium" />
        <Row justify="end">
          <Space>
            <Button onClick={close}>Anuluj</Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={!issue.id}
              loading={is_saving}
            >
              Zapisz
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditIssue;
